import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function Clarity() {
  const { data } = useSelector(state => state.store);

  useEffect(() => {
    if (!data?.empresa) return;

    const clarityId = data.empresa.clarity_id;

    if (clarityId) {
      loadClarity(clarityId);
    }
  }, [data]);

  const loadClarity = (clarityId) => {
    // Verifica se já foi carregado
    if (window.clarity) return;

    (function(c, l, a, r, i, t, y) {
      c[a] = c[a] || function() { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', clarityId);

    console.log(`[Clarity] Carregado com ID: ${clarityId}`);
  };

  return null;
}
